import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from '@/features/form-system/types/template/advance-logic';
import { templateParameterV1Schema } from '@/features/form-system/types/template/parameter';
import { templateReferenceV1Schema } from '@/features/form-system/types/template/reference';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateTextareaSchema = templateNamedWidgetSchema.extend({
  type: z.literal('textarea'),
  placeholder: z.string(),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  value: z.string(),
  reference: templateReferenceV1Schema,
  parameter: templateParameterV1Schema.optional(),
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
  height: z.number().optional(),
});

export type TemplateTextareaV1 = z.infer<typeof templateTextareaSchema>;
